import { render, staticRenderFns } from "./ChatLoading.vue?vue&type=template&id=4bbea465&scoped=true"
import script from "./ChatLoading.vue?vue&type=script&lang=js"
export * from "./ChatLoading.vue?vue&type=script&lang=js"
import style0 from "./ChatLoading.vue?vue&type=style&index=0&id=4bbea465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbea465",
  null
  
)

export default component.exports